<template>
  <div>
    <div class="main-title">考试登记</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button icon="el-icon-edit-outline" type="primary" @click="openForm">考试登记</el-button>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择科目"
              @change="search(searchParams)"
              style="width:250px;">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索学员姓名或身份证"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              @input="inputSearch(searchParams)">
              <el-button slot="append" @click="readSearchIdcard">读身份证</el-button>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        :data="list"
        stripe
        border
        :height="tableHeight"
        :row-class-name="tableRowClassName"
        style="width:100%">
        <el-table-column
          prop="company_name"
          label="所属科目"
          width="100">
        </el-table-column>
        <el-table-column
          prop="idcard"
          label="身份证号"
          sortable
          width="170">
        </el-table-column>
        <el-table-column
          prop="create_at"
          label="考试登记时间"
          sortable
          width="160">
        </el-table-column>
        <el-table-column
          prop="name"
          label="学员姓名"
          sortable
          width="110">
        </el-table-column>
        <el-table-column
          prop="ks_car"
          label="考试车号"
          sortable
          width="110">
        </el-table-column>
        <el-table-column
          prop="end_time"
          label="上次用车时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="price_type"
          label="计费方式"
          width="110">
        </el-table-column>
        <el-table-column
          prop="pay_total"
          label="实收"
          width="70">
        </el-table-column>
        <el-table-column
          prop="student_fee"
          label="人均"
          width="70">
        </el-table-column>
        <el-table-column
          prop="bill_no"
          label="单据编号"
          width="90">
        </el-table-column>
        <el-table-column
          prop="car_alias"
          label="车辆编号"
          width="90">
        </el-table-column>
        <el-table-column
          prop="licnum"
          label="车牌号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="school_name"
          label="驾校"
          width="100">
        </el-table-column>
        <el-table-column
          prop="coach_name"
          label="教练"
          width="80">
        </el-table-column>
        <el-table-column
          prop="start_time"
          label="开始时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="end_time"
          label="结束时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="use_time"
          label="训练时长"
          width="80">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="200"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="90">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">修改</el-button>
            <el-button type="text" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加考试记录表单 -->
    <el-dialog title="添加考试记录" width="440px" top="30vh" :visible.sync="formVisible">
      <el-form :model="form" ref="form" :rules="formRules" label-width="100px">
        <el-form-item label="考试科目">
          <el-select v-model="form.company_id">
            <el-option v-for="company in companyList" :key="company.value" :label="company.label" :value="company.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号码">
          <el-input v-model="form.idcard">
            <el-button slot="append" @click="readIdcard">读身份证</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="学员姓名">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="考试车号">
          <el-select v-model="form.car_id">
            <el-option v-for="i in subjectCarList" :key="i.id" :label="i.car_alias" :value="i.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="startCommit" :loading="startCommiting" :disabled="!form.idcard">确 定</el-button>
        <el-button @click="formVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <audio ref="audio"></audio>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
import _ from 'lodash'
export default {
  mixins: [ListFunc, DatePickerOptions],
  data () {
    return {
      sqlcode: 'kc_exam',
      searchForm: {
        query: '',
        company_ids: [],
        daterange: [
          new Date(),
          new Date()
        ]
      },
      formVisible: false,
      form: {
        id: 0,
        company_id: 0,
        idcard: '',
        name: '',
        car_id: null,
      },
      formRules: {
        name: [
          { required: true, message: '请输入学员证件号码', trigger: 'blur' }
        ],
      },
      startCommiting: false,
      idcardReading: false,
      companyList: [],
      pageSize: 100,
      carList: []
    }
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return this.searchForm
      } else {
        return {
          query: this.searchForm.query,
          company_ids: this.searchForm.company_ids,
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      }
    },
    subjectCarList () {
      return this.carList.filter(car => car.company_id == this.form.company_id)
    }
  },
  mounted () {
    this.fetchCompanyList()
    this.fetchCarList()
    this.$refs.audio.src = require('../../assets/1652771015BEKh.mp3')
    // this.$refs.audio.pause()
    setInterval(() => {
      this.$http.get('/api/heart')
    }, 10 * 60 * 1000)
  },
  methods: {
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
          this.searchForm.company_ids = this.companyList.map(c => c.value)
          this.form.company_id = this.companyList[0].value
        }
      })
    },
    fetchCarList () {
      this.$http.get('/dbapi/car_list').then(response => {
        if (response.data.success) {
          this.carList = response.data.list
        }
      })
    },
    tableRowClassName ({row, rowIndex}) {
      if (!row.end_time) {
        return 'row-bg-red'
      }
      if (moment().diff(moment(row.end_time), 'days') > 10) {
        return 'row-bg-blue'
      }
      if (row.package_color == 'green') {
        return 'row-bg-green'
      }
      if (row.package_color == 'yellow') {
        return 'row-bg-yellow'
      }
      if (row.price_type == '按分钟计费') {
        return 'row-bg-red'
      }
    },
    startCommit: _.throttle( // 提交
      function () {
        if (this.form.id == 0 && !!this.list.find(r => r.idcard == this.form.idcard)) {
          this.$refs.audio.play()
          this.form.idcard = ''
          this.form.name = ''
          this.form.car_id = null
          return
        }
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.startCommiting = true
            if (this.form.id > 0) {
              this.$http.post('/dbapi/update_kc_exam', this.form).then(response => {
                this.startCommiting = false
                if (response.data.success) {
                  this.$message({
                    type: 'success',
                    message: '修改成功'
                  })
                  this.formVisible = false
                  this.form.id = 0
                  this.form.idcard = ''
                  this.form.name = ''
                  this.form.car_id = null 
                  this.refresh()
                } else {
                  this.$message({
                    type: 'error',
                    message: response.data.message
                  })
                }
              })
            } else {
              this.$http.post('/dbapi/insert_kc_exam', this.form).then(response => {
                this.startCommiting = false
                if (response.data.success) {
                  this.$message({
                    type: 'success',
                    message: '登记成功'
                  })
                  // this.formVisible = false
                  this.$refs.audio.play()
                  this.form.idcard = ''
                  this.form.name = ''
                  this.form.car_id = null 
                  this.refresh()
                } else {
                  this.$message({
                    type: 'error',
                    message: response.data.message
                  })
                }
              })
            }
          }
        })
      },
      1000
    ),
    openForm () {
      this.form.id = 0
      this.form.idcard = ''
      this.form.name = ''
      this.form.car_id = null
      this.formVisible = true
      setTimeout(() => {
        this.readIdcard()
      }, 1000)
    },
    edit (item) {
      this.form.id = item.id
      this.form.idcard = item.idcard
      this.form.name = item.name
      this.form.car_id = item.car_id
      this.formVisible = true
    },
    readIdcard () { // 读身份证
      if(this.formVisible && !this.idcardReading) {
        this.idcardReading = true
        this.$idcard.read().then(data => {
          this.idcardReading = false
          this.form.name = data.name
          this.form.idcard = data.code
          this.startCommit()
          setTimeout(() => {
            this.readIdcard()
          }, 1000)
        }).catch((e) => {
          this.idcardReading = false
          if (e != '需要安装插件') {
            setTimeout(() => {
              this.readIdcard()
            }, 1000)
          }
        })
      }
    },
    readSearchIdcard () {
      if(!this.idcardReading) {
        this.idcardReading = true
        this.$idcard.read().then(data => {
          this.idcardReading = false
          this.searchForm.query = data.code
          this.search(this.searchParams)
        }).catch((e) => {
          this.idcardReading = false
        })
      }
    },
    del (row) {
      this.$confirm(`确定要删除这条记录吗？[${row.idcard}]`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/del_kc_exam', {
          id: row.id
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/exam/Index.vue